import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
} from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";

export default class Insertpresent7 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      REGISTER_ID: null,
      V1: "0",
      V2: "0",
      V3: "0",
      V4: "0",
      V5: "0",
      V6: "0",
      V7: "0",
      V8: "0",
      V9: "0",
      V10: "0",
      V_ALL1: "0",
      V_ALL: null,
    };
    this.handleNewsChange = this.handleNewsChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    axios
      .get(
        "https://admission.kpru.ac.th/admission2017/student/loadpresent/" +
          localStorage.getItem("ID_LOGIN")
      )
      .then((respone) => {
        respone.data = respone.data.filter(({ REGISTER_STATUS }) => !(REGISTER_STATUS === "11"));
        this.setState({ REGISTER_ID: respone.data[0]["REGISTER_ID"] });
        // axios.get("https://git.kpru.ac.th/admission2017/student_insertpresent7/profilenews/"+respone.data[0]["REGISTER_ID"]).then((res) => {
        axios
          .get(
            "https://admission.kpru.ac.th/admission2017/student_insertpresent7/profilenews/" +
              respone.data[0]["REGISTER_ID"]
          )
          .then((res) => {
            if (res.data.length !== 0) {
              this.setState({ V1: res.data[0]["V1"] });
              this.setState({ V2: res.data[0]["V2"] });
              this.setState({ V3: res.data[0]["V3"] });
              this.setState({ V4: res.data[0]["V4"] });
              this.setState({ V5: res.data[0]["V5"] });
              this.setState({ V6: res.data[0]["V6"] });
              this.setState({ V7: res.data[0]["V7"] });
              this.setState({ V8: res.data[0]["V8"] });
              this.setState({ V9: res.data[0]["V9"] });
              this.setState({ V10: res.data[0]["V10"] });
              // this.setState({ V11: res.data[0]["V11"] });
              if (res.data[0]["V_ALL"]) {
                this.setState({ V_ALL1: "1" });
                this.setState({ V_ALL: res.data[0]["V_ALL"] });
              } else {
                this.setState({ V_ALL1: "0" });
                this.setState({ V_ALL: null });
              }
            }
          });
      });
  }

  handleNewsChange(event) {
    if (event.target.checked) {
      this.setState({ [event.target.name]: "1" });
    } else {
      this.setState({ [event.target.name]: "0" });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    let bodydata = {
      REGISTER_ID: this.state.REGISTER_ID,
      V1: this.state.V1,
      V2: this.state.V2,
      V3: this.state.V3,
      V4: this.state.V4,
      V5: this.state.V5,
      V6: this.state.V6,
      V7: this.state.V7,
      V8: this.state.V8,
      V9: this.state.V9,
      V10: this.state.V10,
      V_ALL1: this.state.V_ALL1,
      V_ALL: this.state.V_ALL,
    };
    // axios.post("https://git.kpru.ac.th/admission2017/student_insertpresent7/updatepresent/"+this.state.REGISTER_ID, bodydata).then((data) => {
    axios
      .post(
        "https://admission.kpru.ac.th/admission2017/student_insertpresent7/updatepresent/" +
          this.state.REGISTER_ID,
        bodydata
      )
      .then((data) => {
        window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Insertpresent8`;
      });
  }

  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลช่องทางการรับข่าวสารการรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลช่องทางการรับข่าวสารการรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta
            property="og:title"
            content="ข้อมูลช่องทางการรับข่าวสารการรับสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร"
          />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          <h4>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
          <form onSubmit={this.handleSubmit}>
            <MDBRow>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
              <MDBCol lg="10" md="12" sm="12">
                <MDBCard>
                  <MDBCardBody>
                    <MDBContainer fluid>
                      <MDBRow>
                        <MDBCol>
                          <MDBCardTitle>ข้อมูลช่องทางการได้รับข่าวสารการรับสมัคร</MDBCardTitle>
                          <MDBCardText>
                            <div className="form-outline mt-2">
                              <label className="form-label">
                                ท่านรับทราบข่าวสารการรับสมัคร ผ่านช่องทางใดบ้าง (ตอบได้มากกว่า 1
                                ข้อ)
                              </label>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V1"
                                  name="V1"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V1 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V1">
                                  {" "}
                                  เว็บไซต์มหาวิทยาลัยราชภัฏกำแพงเพชร
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V2"
                                  name="V2"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V2 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V2">
                                  {" "}
                                  โปสเตอร์/แผ่นประกาศ/แผ่นพับ/ใบปลิว
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V3"
                                  name="V3"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V3 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V3">
                                  {" "}
                                  YouTube / Tiktok
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V4"
                                  name="V4"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V4 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V4">
                                  {" "}
                                  สื่อวิทยุ
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V5"
                                  name="V5"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V5 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V5">
                                  {" "}
                                  ผู้ปกครอง
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V6"
                                  name="V6"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V6 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V6">
                                  {" "}
                                  Facebook
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V7"
                                  name="V7"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V7 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V7">
                                  {" "}
                                  ครูแนะแนว
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V8"
                                  name="V8"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V8 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V8">
                                  {" "}
                                  ป้ายประชาสัมพันธ์
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V9"
                                  name="V9"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V9 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V9">
                                  {" "}
                                  นิทรรศการวิชาการ
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V10"
                                  name="V10"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V10 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V10">
                                  {" "}
                                  แนะแนวการศึกษาของมหาวิทยาลัย
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="V_ALL1"
                                  name="V_ALL1"
                                  onChange={this.handleNewsChange}
                                  checked={this.state.V_ALL1 === "1" ? true : false}
                                />
                                <label className="form-check-label" for="V_ALL1">
                                  {" "}
                                  อื่นๆ
                                </label>
                              </div>
                            </div>
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>

                      {this.state.V_ALL1 === "1" ? (
                        <>
                          <MDBRow>
                            <MDBCol>
                              <MDBCardText>
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="V_ALL">
                                    เพิ่มเติม <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="V_ALL"
                                    name="V_ALL"
                                    value={this.state.V_ALL}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      ) : (
                        <></>
                      )}

                      {this.state.V1 === "1" ||
                      this.state.V2 === "1" ||
                      this.state.V3 === "1" ||
                      this.state.V4 === "1" ||
                      this.state.V5 === "1" ||
                      this.state.V6 === "1" ||
                      this.state.V7 === "1" ||
                      this.state.V8 === "1" ||
                      this.state.V9 === "1" ||
                      this.state.V10 === "1" ||
                      (this.state.V_ALL1 === "1" && this.state.V_ALL) ? (
                        <>
                          <button type="submit" className="btn btn-primary btn-rounded btn-md mt-2">
                            บันทึกข้อมูล
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            type="submit"
                            className="btn btn-primary btn-rounded btn-md mt-2"
                            disabled
                          >
                            บันทึกข้อมูล
                          </button>
                        </>
                      )}
                    </MDBContainer>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
            </MDBRow>
          </form>
        </MDBContainer>
      </>
    );
  }
}


